// extracted by mini-css-extract-plugin
module.exports = {"root":"_eb2afa","text":"_75b9e8","userIconBgExp":"_dce55e"};